import React from 'react';
import { Badge } from '../../../components/ui';

// Tipos válidos de estado enviados por el backend
export type EstadoPremio = 'PENDIENTE' | 'CAMBIADO' | 'ANULADO' | 'VENCIDO';

interface EstadoConfig {
  variant: 'warning' | 'success' | 'danger';
  label: string;
  className?: string;
}

// Fuente única de verdad para el mapping estado → badge
export const ESTADO_PREMIO_CONFIG: Record<EstadoPremio, EstadoConfig> = {
  PENDIENTE: { variant: 'warning', label: 'Pendiente' },
  CAMBIADO:  { variant: 'success', label: 'Cambiado' },
  ANULADO:   { variant: 'danger',  label: 'Anulado' },
  // VENCIDO: naranja — distinguible de ANULADO (rojo) y PENDIENTE (amarillo)
  VENCIDO:   { variant: 'warning', label: 'Vencido', className: 'bg-orange-100 text-orange-700' },
};

interface EstadoPremioBadgeProps {
  estado?: string | null;
}

/**
 * Muestra un Badge con el estado del premio.
 * Si el campo no llega (legado), muestra guión gris — no asume Pendiente.
 */
export const EstadoPremioBadge: React.FC<EstadoPremioBadgeProps> = ({ estado }) => {
  if (!estado) {
    return <span className="text-gray-400">—</span>;
  }
  const cfg = ESTADO_PREMIO_CONFIG[estado as EstadoPremio];
  if (!cfg) {
    return <span className="text-gray-400">—</span>;
  }
  return (
    <Badge variant={cfg.variant} className={cfg.className ?? ''}>
      {cfg.label}
    </Badge>
  );
};
